import { useCallback } from "react";
import WhatsAppShareButton from "./WhatsAppShareButton";
import { generateVerseImage } from "../lib/verseImage";
import content from "../content";

export default function VerseShare() {
  const { verse, brand } = content;
  const s = verse.share;
  const v = verse.versions.find((x) => x.id === s?.version) || verse.versions[0];

  const getFile = useCallback(async () => {
    const blob = await generateVerseImage({
      text: v.text,
      reference: v.reference,
      highlight: v.highlight,
      eyebrow: verse.eyebrow,
      footer: s.footer,
      logo: brand.logo,
      bgImage: s.bgImage,
    });
    return new File([blob], s.fileName, { type: "image/png" });
  }, [v, verse.eyebrow, s, brand.logo]);

  if (!s || s.hidden) return null;

  const text = `"${v.text}" — ${v.reference}\n\n${s.footer}\n${window.location.origin}`;

  return <WhatsAppShareButton getFile={getFile} text={text} labels={s} testId="verse-share-btn" className="mt-12" />;
}
